import { render, staticRenderFns } from "./ImproveWritingButton.vue?vue&type=template&id=1458e177"
import script from "./ImproveWritingButton.vue?vue&type=script&lang=js"
export * from "./ImproveWritingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports